import React from 'react';

const DeleteImage = () => {
    return (
        <div>
            {/* Add your code here */}
        </div>
    );
};

export default DeleteImage;
